import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Method() {
  return <section className="bg-cream py-16 sm:py-24" aria-labelledby="method-title" data-id="element-82" data-mp="71u7kobyath3">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2 lg:gap-16" data-id="element-83" data-mp="c1glz13imfrh">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.55
      }} className="order-2 overflow-hidden rounded-[2rem] border-8 border-white shadow-soft lg:order-1" data-id="element-84" data-mp="h1l0wmorz2fl">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/2594dcb4-7a6f-4700-9c5f-2355aa8223cd.jpg" alt="Profesora del Método Maestro Amigurumi sosteniendo un muñeco tejido a mano" className="h-full w-full object-cover" data-id="element-85" data-mp="3pfa6hzmsiemv" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.35
      }} transition={{
        duration: 0.55
      }} className="order-1 lg:order-2" data-id="element-86" data-mp="31qqtj6sspdog">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-87" data-mp="fplh5xnddwif">
            La revelación
          </span>
          <h2 id="method-title" className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-[2.6rem]" data-id="element-88" data-mp="bot5kxr0zfiz">
            Presentamos el Método Maestro Amigurumi
          </h2>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-muted" data-id="element-89" data-mp="1panynyl85u3">
            <p data-id="element-90" data-mp="3sw53trxybev8">
              Destilé años de experiencia en una guía digital práctica que elimina la confusión.
              Este no es solo “un curso de tejido”: es el mapa exacto para que tus manos hagan
              realidad cualquier diseño que imagines.
            </p>
            <p data-id="element-91" data-mp="1r2nw6o9tme0h">
              Aprendé a tu ritmo, desde la comodidad de tu casa, y convertí el tejido en tu terapia
              diaria y, por qué no, en tu nuevo emprendimiento.
            </p>
          </div>
          <div className="mt-8 max-w-lg" data-id="element-92" data-mp="3gk2nd46i7vqx">
            <CtaButton data-id="element-93" data-mp="3ldnpn8f4rbvx" />
          </div>
        </motion.div>
      </div>
    </section>;
}